module.exports = __webpack_public_path__ + "img/title2.d781c183.png";